<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <interes-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import InteresProvider from "../../../../providers/InteresProvider";
    
    import {CrudUpdate, ClientError} from '@dracul/common-frontend'
    
    import InteresForm from "../InteresForm";
  
    import {Dayjs} from "@dracul/dayjs-frontend";

    export default {
        name: "InteresUpdate",
        
        components: { InteresForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'cobrox.interes.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    fechaDesde: this.item.fechaDesde?Dayjs(parseInt(this.item.fechaDesde)):null,
                    fechaHasta: this.item.fechaHasta?Dayjs(parseInt(this.item.fechaHasta)):null,
                    importeDesde: this.item.importeDesde,
                    importeHasta: this.item.importeHasta,
                    tasa: this.item.tasa
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    InteresProvider.updateInteres(this.id, this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateInteres)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

